import { returnAction } from '../return-action.util';
import { ActionEnum } from '../../../enum/action.enum';
import { IUpdateLogosPayload } from '../../../action/settings.action';
import { ILogo } from '../../../interface/block/logo.interface';

export const updateLogos = (logos: ILogo[]) => returnAction<IUpdateLogosPayload>(ActionEnum.SETTINGS_UPDATE_LOGOS, {logos});
